import { PMDBMIData } from 'models/patientMedicalData';
import { Document } from '@extrahorizon/javascript-sdk';
import { BsCheckCircleFill, BsExclamationCircleFill, BsQuestionCircleFill } from 'react-icons/bs';
import { IconType } from 'react-icons';

export type WeightMeasurement = Document<PMDBMIData>;

export enum WeightIndicator {
  Underweight = 'underweight',
  Normal = 'normal',
  Overweight = 'overweight',
  Obesity = 'obesity',
  NoResult = 'no_result',
}

export const WeightIndicatorMap: { [key in WeightIndicator]: { color: string; Icon?: IconType } } = {
  obesity: { color: 'var(--mantine-color-red-5)', Icon: BsExclamationCircleFill },
  overweight: { color: 'var(--mantine-color-peach-7)', Icon: BsExclamationCircleFill },
  normal: { color: 'var(--mantine-color-turquoise-5)', Icon: BsCheckCircleFill },
  underweight: { color: 'var(--mantine-color-peach-7)', Icon: BsExclamationCircleFill },
  no_result: { color: 'var(--mantine-color-gray-5)', Icon: BsQuestionCircleFill },
};
